import React from "react";
import { useTranslation } from "../hooks/hooks";
import GamesLobby from "../components/GamesLobby";
import HotGamesLobby from "../components/HotGamesLobby";
import NewGamesLobby from "../components/NewGamesLobby";
import GameofWeek from "../components/GameofWeek";
import ProvidersSlider from "../components/ProvidersSlider";
import Search from "../components/Search";
import BannersSlider from "../components/BannersSlider";
import PaymentsSlider from "../components/PaymentsSlider";
import FavoriteGames from "../components/FavoriteGames";
import {
    activeCategoryAtom,
    activeProvidersAtom,
    categoriesAtom,
    categoryTypeAtom,
    userIsLoggedInAtom,
} from "../state/games";
import { useAtom } from "jotai";
import MobileCategories from "../components/MobileCategories";
declare const banners: string[];

const Lobby = () => {
    const { _e } = useTranslation();
    const [userIsLoggedIn] = useAtom(userIsLoggedInAtom);
    const [activeCategory, setActiveCategory] = useAtom(activeCategoryAtom);
    const [categories] = useAtom(categoriesAtom);
    const [, setCategoryType] = useAtom(categoryTypeAtom);
    const [activeProvider, setActiveProvider] = useAtom(activeProvidersAtom);

    const categoryHandler = (category_id: number) => {
        if (category_id === 0) {
            setActiveCategory(0);
            setActiveProvider([]);
        } else {
            setActiveCategory(category_id);
        }
    };
    return (
        <>
            <BannersSlider banners={banners} />
            <div className="filters filters-lobby">
                <Search />
                <ProvidersSlider />
            </div>
            {categories && (
                <MobileCategories
                    activeCategory={activeCategory}
                    categories={categories}
                    setCategoryType={setCategoryType}
                    updateCategory={categoryHandler}
                />
            )}

            <PaymentsSlider />
            {userIsLoggedIn && <FavoriteGames />}
            <div className="flex lobby-promo-games">
                <div className="left">
                    <HotGamesLobby />
                    <NewGamesLobby />
                </div>
                <div className="right">
                    <GameofWeek />
                </div>
            </div>
            <GamesLobby />
        </>
    );
};

export default Lobby;
